module.exports = __webpack_public_path__ + "media/images/flags/vu-8def2fadd8ad3cae53fe460c064e9a81.svg";